<template>
  <div>
    <PressScrapCostComponent :regMode="true" />
  </div>
</template>

<script>

import PressScrapCostComponent from './PressScrapCostComponent'
export default {
  name: 'PressScrapCost',
  data: function () {
    return {
    }
  },
  components: {
    PressScrapCostComponent
  },
  created () {

  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
